import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { WithStyles, Theme, createStyles, withStyles, Typography } from '@material-ui/core'
import { INews } from 'src/type/news'
import NewsCard from 'src/shared/News/NewsCard'
import { connect } from 'react-redux'
import { RootState } from 'src/core/redux/reducer'
import { withRouter, RouteComponentProps } from 'react-router'
import {css} from 'src/conf/style'

const styles = (t: Theme) => createStyles({
    alertEmpty: {
        ...css.flexFullCenter,
        height: '100%'
    }
});

interface IProps extends WithI18n,
  RouteComponentProps<any>,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>{
    entities: INews[];
}


class EcoWatchCard extends React.Component<IProps, {}> {

  render() {
    const {t, classes, entities} = this.props
    return (
        <>
            {entities &&
                entities.map(n => {
                    return (
                        <div key={`eco-watch-wpr-${n.id}`} style={{marginBottom: '15px'}}>
                            <NewsCard key={`eco-watch-news-${n.id}`} entity={n} pathNews={this.props.match.path} withChip={true}/>
                        </div>
                    )
                })
            }
            {entities && entities.length === 0 &&
                <div className={classes.alertEmpty}>
                    <Typography variant="body2">{t.news_no_post_in_categories}</Typography>
                </div>
            }
        </>
    )
  }


}

const state2props = (state: RootState) => ({
    enterprise: state.accountInfo.enterpriseSelected,
});


export default compose(
    withI18n,
    withRouter,
    withStyles(styles),
    connect(state2props, null)
)(EcoWatchCard)



// WEBPACK FOOTER //
// ./src/page/Consumer/EcoWatch/EcoWatchCard.tsx